import initNav from "../scripts/nav";

initNav();
